import { z } from "zod";
/**
 * Every provider object is addressed as `{accountId}:{providerId}` (architecture §6.2). Account
 * ids are our own (`acc_` + 20 base62 chars); provider ids are opaque and may contain colons
 * (Graph immutable ids are base64), so only the first colon separates the two.
 */
export const AccountId = z.string().regex(/^acc_[0-9A-Za-z]{20}$/, "invalid account id");
export const ScopedId = z
    .string()
    .regex(/^acc_[0-9A-Za-z]{20}:.+$/, "expected <accountId>:<providerId>");
export function scopedId(accountId, providerId) {
    if (providerId.length === 0)
        throw new Error("providerId is empty");
    return ScopedId.parse(`${accountId}:${providerId}`);
}
export function parseScopedId(value) {
    const parsed = ScopedId.parse(value);
    const at = parsed.indexOf(":");
    return { accountId: AccountId.parse(parsed.slice(0, at)), providerId: parsed.slice(at + 1) };
}
//# sourceMappingURL=ids.js.map